import { render, staticRenderFns } from "./mosesRobot.vue?vue&type=template&id=de92e5f8&scoped=true&"
import script from "./mosesRobot.vue?vue&type=script&lang=ts&"
export * from "./mosesRobot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de92e5f8",
  null
  
)

export default component.exports